import { render, staticRenderFns } from "./pos-print-barcode.vue?vue&type=template&id=2036fa90&scoped=true&"
import script from "./pos-print-barcode.vue?vue&type=script&lang=ts&"
export * from "./pos-print-barcode.vue?vue&type=script&lang=ts&"
import style0 from "./pos-print-barcode.vue?vue&type=style&index=0&id=2036fa90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2036fa90",
  null
  
)

export default component.exports